export const CREATE_EVENT_ACTION = 'events/created';
export const UPDATE_STEPS_ACTION = 'steps/updated';
export const USER_ACTION = 'user/details';
export const AUTH_ACTION = 'auth/permitted';
export const ADD_EVENT_DETAIL = 'add/detail';
export const USER_ACTION_ADD = 'user/details/add';
export const RESET_EVENT_DETAIL = 'reset/detail';